const texts = document.querySelectorAll(".medallions__about");

texts.forEach(text => {
  text.addEventListener("click", expand);
  text.innerHTML = text.innerHTML.substring(0, 220) + "...";
});

function expand(e) {
  e.target.classList.add("medallions__about--expanded");
  e.target.innerHTML = e.target.dataset.text;
}
